import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import MyButton from '../../util/MyButton'
import PostOpinion from '../wreck/PostOpinion'
import Notifications from './Notifications'

//Material-UI stuff
import Fab from '@material-ui/core/Fab';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import HomeIcon from '@material-ui/icons/Home'
import { withStyles } from '@material-ui/core'

const styles = (theme) => ({
    ...theme.spreadThis,
    appBar: {
        top: 'auto',
        bottom: 0,
      },
      grow: {
        margin: theme.spacing(0, 'auto'),
        display: 'block'
      },
      spaced: {
        margin: theme.spacing(0, 12),
        display: 'inline'
      },
      fabButton: {
        position: 'absolute',
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto',
      }
})

class Navbar extends Component {
    render() {
        const {authenticated, classes } = this.props;
        return (
            <div>
                    {authenticated ? (
                        <Fragment>
                            <AppBar position="fixed" color="primary" className={classes.appBar}>
                                <Toolbar>
                                    
                                    <Fab color="secondary" aria-label="add" className={classes.fabButton}>
                                        <PostOpinion />
                                    </Fab>
                                    <div className={classes.grow}>
                                        <Link to='/'>
                                            <MyButton tip='Home'>
                                                <HomeIcon fontSize="large" style={{ color: 'white' }}/>
                                            </MyButton>
                                        </Link>
                                        <div className={classes.spaced} />
                                        <Notifications />
                                    </div>
                                    
                                </Toolbar>
                            </AppBar>
                        </Fragment>
                    ) : (
                        <AppBar>
                            <Toolbar className="nav-container">
                                <Fragment>
                                    <Button color='inherit' component={Link} to='/'>Home</Button>
                                    <Button color='inherit' component={Link} to='/login'>Login</Button>
                                    <Button color='inherit' component={Link} to='/signup'>Signup</Button>
                                </Fragment>
                            </Toolbar>   
                        </AppBar>
                    )}
                     
            </div>
        )
    }
}

Navbar.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    authenticated: state.user.authenticated
})


export default connect(mapStateToProps)(withStyles(styles)(Navbar));
